<app-overlay-panel fullWidth="true" [isShowing]="isShowing">
    <div class="overlay-header-item truck-journey-load-assignment-header">
        <div class="truck-journey-load-assignment-header-item">
            <button type="button" class="btn btn-secondary btn-lg btn-outline btn-white"
                    (click)="cancelAndCloseLoadAssignment()">
                <i class="fa fa-arrow-left"></i>
            </button>
        </div>
        <div class="truck-journey-load-assignment-header-item">
            <h1 [i18n]="[{target: 'innerHTML', key: 'truck-journeys.load-assignment.header-with-context',
                params: { truckJourneyContext: truckJourneyLabel }}]">
            </h1>
        </div>
    </div>
    <div class="overlay-content">
        <app-truck-journey-load-assignment
            [excludedJourneyId]="truckJourney?.id"
            #loadAssignment
            [(selectedLoads)]="newLoadsSelection">
        </app-truck-journey-load-assignment>
    </div>
    <div class="overlay-footer-item">
        <button type="button" (click)="cancelAndCloseLoadAssignment()" class="btn">
            <span [i18n]="'truck-journeys.load-assignment.button.cancel'"></span>
        </button>
        <button type="button" (click)="assignLoads()" class="btn btn-primary">
            <span [i18n]="'truck-journeys.load-assignment.button.assign-to-this-truck-journey'"></span>
        </button>
    </div>
</app-overlay-panel>
